export default "__VITE_ASSET__2f688cf8__"